import { Resource } from '../resource/resource.model';

export interface PreferenceAgentElement {
  ask: string;
  confirm: boolean;
  group: 'contact' | 'preference';
  id?: string;
  order: number;
  orphaned?: boolean;
  refId: string;
  required: boolean;
  resolvedChannelsIds?: string[];
  resolvedDescription?: string;
  resolvedFrequenciesIds?: string[];
  resolvedLabel?: string;
  resolvedName?: string;
  resolvedType?: string;
}

export interface PreferenceAgentDesign {
  accent: string;
  avatar: string;
  bubble: string;
  density: string;
  showCount: boolean;
  showProgress: boolean;
}

export interface PreferenceAgentBehavior {
  allowLookup: boolean;
  allowSkip: boolean;
  allowUnsubscribe: boolean;
  language: string;
  stayOnTopic: boolean;
  tone: string;
}

export interface PreferenceAgentData {
  createContact: boolean;
  fallbackPageId?: string;
  writeContact: boolean;
}

export class PreferenceAgent extends Resource {
  public behavior?: PreferenceAgentBehavior;
  public businessUnit: string;
  public createdAt?: string;
  public data?: PreferenceAgentData;
  public description?: string;
  public design?: PreferenceAgentDesign;
  public elements: PreferenceAgentElement[] = [];
  public farewell?: string;
  public name: string;
  public redirectUrl?: string;
  public slug?: string;
  public status?: 'draft' | 'live';
  public tenantId?: string;
  public updatedAt?: string;
  public welcome?: string;
}

// Public (anonymous) chat wire contract — Phase C backend, camelCase 1:1, no serializer involved.

export interface PublicAgentDesign {
  accent: string;
  avatar: string;
  bubble: string;
  density: string;
  showCount: boolean;
  showProgress: boolean;
}

export interface PublicAgentConfig {
  allowSkip: boolean;
  design: PublicAgentDesign;
  elementsCount: number;
  fallbackPageId?: string;
  name: string;
  status: 'draft' | 'live';
  welcome: string;
}

export interface AgentChatUiOption {
  label: string;
  value: string;
}

export interface AgentChatUi {
  field?: string;
  kind: 'text' | 'yesno' | 'quick' | 'multi' | 'done';
  options?: AgentChatUiOption[];
}

export interface AgentChatProgress {
  captured: number;
  total: number;
}

export interface AgentChatTurn {
  captured?: Record<string, string>;
  done: boolean;
  progress?: AgentChatProgress;
  redirectUrl?: string;
  reply: string;
  ui: AgentChatUi;
  unsubscribed?: boolean;
}

export interface AgentChatStart {
  conversationId: string;
  turn: AgentChatTurn;
  welcome: string;
}
